import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

import {
  Grid,
  Button,
  FormLabel,
  CircularProgress,
  Avatar,
} from '@material-ui/core';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import { CustomSnackbar, DiscardDialog } from '../';

import AWS from '../../utils/api-controllers/aws/AWS';
import { makeid } from '../../utils/utilFunctions';
import { styles } from './styles';

class UploadImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isImageUpload: true,
      isImageUploading: false,
      image: props.image ? props.image : '',
      message: '',
      messageType: '',
      openSnackbar: false,
      filename: '',
    };
  }

  successCallback = url => {
    this.setState({
      image: url,
      isImageUploading: false,
      isImageUpload: false,
    });
  };

  failureCallback = () => {
    this.setState({
      image: '',
      filename: '',
      openSnackbar: true,
      isImageUpload: true,
      isImageUploading: false,
      messageType: 'Error',
      message: 'Error uploading an image. Please contact Admin!',
    });
  };

  callImageUpload = e => {
    let fileTypes = 'image/png,image/jpeg';

    if (e.target.files.length > 0) {
      if (fileTypes.split(',').indexOf(e.target.files[0].type) !== -1) {
        if (e.target.files[0].size <= 2 * 1024 * 1024) {
          let newlygeneratedFileName = makeid(e.target.files[0].name.length);
          this.setState({
            isImageUploading: true,
            filename: newlygeneratedFileName,
            filetype: e.target.files[0].type,
          });
          let file = e.target.files[0];
          AWS.uploadToS3(
            file,
            newlygeneratedFileName,
            this.successCallback,
            this.failureCallback,
          );
        } else {
          this.setState({
            openSnackbar: true,
            messageType: 'Error',
            message: 'Size must not exceed 2MB',
          });
        }
      } else {
        this.setState({
          openSnackbar: true,
          messageType: 'Error',
          message: 'Only png, jpg and jpeg files are allowed',
        });
      }
    } else {
      this.removeImage(e);
    }
  };

  onRemoveSuccess = () => {
    this.setState({
      image: '',
      filename: '',
      isImageUpload: true,
      isImageUploading: false,
    });
  };

  onRemoveFailure = () => {
    this.setState({
      image: '',
      filename: '',
      openSnackbar: true,
      isImageUpload: true,
      isImageUploading: false,
      messageType: 'Error',
      message: 'Error removing an image. Please contact Admin!',
    });
  };

  removeImage = e => {
    if (this.state.image && this.state.filename) {
      AWS.deleteFileFromS3(
        {
          filename: this.state.filename,
          bucketname: 'guest_pictures_bucket',
        },
        this.onRemoveSuccess,
        this.onRemoveFailure,
      );
    } else {
      this.setState({
        openSnackbar: true,
        messageType: 'Error',
        message: 'No file to remove!',
      });
    }
  };

  render() {
    const classes = this.props.classes;
    return (
      <div className={classes.imageWrapper}>
        <Grid container md={12} xs={12} className={classes.imageGrid}>
          <Grid item className={classes.avatarImage}>
            <Avatar
              variant="square"
              src={this.state.image || this.props.image}
              alt="Image"
            />
          </Grid>
          <Grid item>
            <ValidatorForm
              onSubmit={this.handleSubmit}
              onError={errors => {
                this.scrollToFirstError(errors);
              }}
              ref={form => (this['formRef'] = form)}
            >
              <Grid container md={12} xs={12} className={classes.uploadButtons}>
                <Grid item md={12} xs={12}>
                  <FormLabel className={classes.customFileUpload}>
                    Click here to upload an image
                    <TextValidator
                      name="image"
                      id="image"
                      disabled={this.props.disabled}
                      onChange={e => this.callImageUpload(e)}
                      type="file"
                      accept="image/x-png,image/jpeg"
                      inputRef={input => (this.image = input)}
                    />
                  </FormLabel>
                </Grid>
                <Grid item md={12} xs={12}>
                  <Button
                    color="primary"
                    type="button"
                    variant="contained"
                    onClick={() =>
                      this.props.uploadSuccessful(
                        this.state.image,
                        this.state.filename,
                        this.state.filetype,
                      )
                    }
                    disabled={this.state.isImageUpload || this.props.disabled}
                    className={classes.uploadButton}
                  >
                    Submit
                  </Button>
                  {this.state.isImageUploading ? (
                    <CircularProgress
                      color="secondary"
                      size={22}
                      className={classes.imageProgress}
                    />
                  ) : null}
                  <Button
                    color="secondary"
                    type="button"
                    variant="contained"
                    disabled={
                      this.state.image == '' || this.props.disabled
                        ? true
                        : false
                    }
                    className={classes.removeButton}
                    onClick={event => this.removeImage(event)}
                    style={
                      this.state.image == '' || this.props.disabled
                        ? null
                        : this.props.style
                    }
                  >
                    Remove
                  </Button>
                </Grid>
              </Grid>
            </ValidatorForm>
          </Grid>
        </Grid>
        <CustomSnackbar
          onClose={() => this.setState({ openSnackbar: false })}
          open={this.state.openSnackbar}
          type={this.state.messageType}
          message={this.state.message}
        />
        <DiscardDialog
          onClose={() => this.setState({ openDiscardDialog: false })}
          open={this.state.openDiscardDialog}
          link={this.state.discardLink}
        />
      </div>
    );
  }
}

export default withStyles(styles)(UploadImage);
